// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollCalendarDto
 */
export interface IPayrollCalendarDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    frequency_type?: IPayrollCalendarDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    status?: IPayrollCalendarDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarDto
     */
    next_autoprolong_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    json_config?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarDto
     */
    group_type?: IPayrollCalendarDtoGroupTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarDto interface.
 */
export function instanceOfIPayrollCalendarDto(value: object): value is IPayrollCalendarDto {
    return true;
}

export function IPayrollCalendarDtoFromJSON(json: any): IPayrollCalendarDto {
    return IPayrollCalendarDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_autoprolong_at': json['next_autoprolong_at'] == null ? undefined : (new Date(json['next_autoprolong_at'])),
        'json_config': json['json_config'] == null ? undefined : json['json_config'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
    };
}

export function IPayrollCalendarDtoToJSON(json: any): IPayrollCalendarDto {
    return IPayrollCalendarDtoToJSONTyped(json, false);
}

export function IPayrollCalendarDtoToJSONTyped(value?: IPayrollCalendarDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString()),
        'status': value['status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_autoprolong_at': value['next_autoprolong_at'] == null ? undefined : ((value['next_autoprolong_at']).toISOString()),
        'json_config': value['json_config'],
        'group_type': value['group_type'],
    };
}

